var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZondicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13513_4149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.63724 15.3632C1.77765 14.533 1.09201 13.5399 0.62033 12.4419C0.148649 11.3438 -0.0996274 10.1629 -0.110012 8.96785C-0.120396 7.77284 0.107319 6.58772 0.559847 5.48166C1.01238 4.37559 1.68065 3.37072 2.52569 2.52569C3.37072 1.68065 4.37559 1.01238 5.48166 0.559847C6.58772 0.107319 7.77284 -0.120396 8.96785 -0.110012C10.1629 -0.0996274 11.3438 0.148649 12.4419 0.62033C13.5399 1.09201 14.533 1.77765 15.3632 2.63724C17.0027 4.33466 17.9098 6.60808 17.8893 8.96785C17.8688 11.3276 16.9223 13.5849 15.2536 15.2536C13.5849 16.9223 11.3276 17.8688 8.96785 17.8893C6.60808 17.9098 4.33466 17.0027 2.63724 15.3632ZM8.10024 4.50024V9.90024H9.90024V4.50024H8.10024ZM8.10024 11.7002V13.5002H9.90024V11.7002H8.10024Z",
    fill: "#FFAC26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13513_4149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZondicons);
export default __webpack_public_path__ + "static/media/zondicons.5e923c00c4ac5ef51ba7eeb2de610f9e.svg";
export { ForwardRef as ReactComponent };